module.exports = __webpack_public_path__ + "media/audio4.dc92de41.mp3";